import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CircleHelp, ChevronDown, BookOpen, ShoppingBag, Shield, ArrowUpRight } from 'lucide-react';
import PageHeading from './PageHeading';
import { ContactCards } from '../pages/CustomerService';

const questions = [
  ['三种产品怎么选？', '代充值：用你自己的账号升级。成品号：提供新账号及相应激活信息。网页共享版：通过交付的网页入口使用。具体交付内容以产品卡片和订单说明为准。'],
  ['购买后在哪里查看交付内容？', '支付成功后查看页面提示，也可在历史订单中打开已完成的订单，查看卡密、账号或网页入口。设有查询密码的订单需要先验证密码。'],
  ['没有收到卡密或网页入口怎么办？', '请先查看订单详情。如果仍未显示，联系右下角在线客服并提供订单号，由客服核对。'],
  ['需要 Invoice 怎么领取？', '联系右下角在线客服，提供订单号即可免费领取 Invoice。'],
  ['广告或其他产品可以代充吗？', '可以联系大师兄咨询。把产品名称、充值金额和需求发给客服，确认方案后再购买。'],
];

export default function SupportPage() {
  const [open, setOpen] = useState(null);
  return (
    <div className="page-shell">
      <PageHeading Icon={CircleHelp} eyebrow="HELP · 帮助中心" title="从购买到使用，一步步来" description="先看教程和常见问题，需要帮助随时找大师兄。" />
      <div className="grid sm:grid-cols-3 gap-4 mb-8">
        {[['/upgrade-guide', BookOpen, '升级与使用教程'], ['/orders', ShoppingBag, '查看历史订单'], ['/after-sales', Shield, '售后服务']].map(([to, Icon, title]) => (
          <Link key={to} to={to} className="page-card flex items-center gap-3 hover:border-brand-line"><Icon className="text-brand shrink-0" size={22} /><strong className="text-sm flex-1">{title}</strong><ArrowUpRight size={16} /></Link>
        ))}
      </div>
      <h2 className="text-xl font-bold mb-4">常见问题</h2>
      <div className="space-y-3 mb-10">
        {questions.map(([title, answer], index) => (
          <div key={title} className="bg-white border border-line rounded-2xl overflow-hidden">
            <button onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={`support-answer-${index}`} className="w-full flex items-center justify-between gap-4 p-5 text-left font-semibold text-sm"><span>{title}</span><ChevronDown size={18} className={`shrink-0 text-brand ${open === index ? 'rotate-180' : ''}`} /></button>
            {open === index && <p id={`support-answer-${index}`} className="px-5 pb-5 text-sm text-muted">{answer}</p>}
          </div>
        ))}
      </div>
      <ContactCards />
    </div>
  );
}
